var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.625 37.508H9.375C7.64982 37.5063 6.25172 36.1082 6.25 34.383V12.508C6.25172 10.7828 7.64982 9.3847 9.375 9.38298H40.625C42.3502 9.3847 43.7483 10.7828 43.75 12.508V34.383C43.7474 36.1078 42.3498 37.5054 40.625 37.508ZM9.375 12.508V34.383H40.625V12.508H9.375ZM3.125 40.633H46.875V43.758H3.125V40.633Z",
    fill: "#F06F30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.54ac7c0da434f17864ac5e1295e1e479.svg";
export { ForwardRef as ReactComponent };